const ACCESS_TYPE_EMEDE = 'EMEDE';
const ACCESS_TYPE_CLIENT = 'CLIENTE';
const ACCESS_TYPE_GLOBAL = 'GLOBAL';
const USER_TYPE_DOCTOR = 'MEDICO';
const USER_TYPE_OTHER = 'USUARIO';
const USER_TYPE_GLOBAL = 'GLOBAL';

export const TYPES_USERS_VALUE_LABEL = [
  {
    value: null,
    label: 'Todos',
  },
  {
    value: USER_TYPE_DOCTOR,
    label: 'Médico',
  },
  {
    value: USER_TYPE_OTHER,
    label: 'Usuário',
  },
];

export const TYPES_ACCESS_VALUE_LABEL = [
  {
    value: null,
    label: 'Todos',
  },
  {
    value: ACCESS_TYPE_EMEDE,
    label: 'Empresa',
  },
  {
    value: ACCESS_TYPE_CLIENT,
    label: 'Cliente',
  },
];

export {
  ACCESS_TYPE_EMEDE,
  ACCESS_TYPE_CLIENT,
  ACCESS_TYPE_GLOBAL,
  USER_TYPE_DOCTOR,
  USER_TYPE_OTHER,
  USER_TYPE_GLOBAL,
};


